/* eslint-disable camelcase */
import { useState } from 'react'

import * as React from 'react'
import { Input, Radio } from 'components/forms'
import { InfoButton } from 'components/buttons'
// @ts-ignore-line
import css from './ViewedContentItems.scss'

interface ViewedContentItem {
  content_id: string
  served_count: number
  served_at: string
}

interface ViewedContentItemsProps {
  onChange: (val: any) => void
}

const ViewedContentItems = (props: ViewedContentItemsProps) => {
  const { onChange } = props
  const [contentItems, setContentItems] = useState<ViewedContentItem[]>([])
  const [contentItemID, setContentItemID] = useState<string>()
  const [contentItemServes, setContentItemServes] = useState<string>()
  const [contentItemDate, setContentItemDate] = useState<undefined | string>()
  const [radioSelection, setRadioSelection] = useState<string>('default')

  return (
    <>
      <div className="control-label">Content Items Served</div>
      <div className={css.ViewedContentItems}>
        <Radio
          checked={radioSelection === 'default'}
          label="Default"
          name="default"
          onChange={() => {
            onChange(undefined)
            setRadioSelection('default')
          }}
        />
        <Radio
          checked={radioSelection === 'clear'}
          label="Clear All Serve Counts"
          name="clear"
          onChange={() => {
            onChange([])
            setRadioSelection('clear')
          }}
        />
        <Radio
          checked={radioSelection === 'custom'}
          label="Custom Values"
          name="custom"
          onChange={() => {
            onChange(contentItems)
            setRadioSelection('custom')
          }}
        />
        <div className={css.Form}>
          <Input
            groupClassName={css.Id}
            disabled={radioSelection !== 'custom'}
            label="Contentful ID"
            type="text"
            value={contentItemID}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setContentItemID(e.currentTarget.value || undefined)
            }
          />
          <Input
            groupClassName={css.Views}
            disabled={radioSelection !== 'custom'}
            label="Served Count"
            type="number"
            value={contentItemServes}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setContentItemServes(e.currentTarget.value || undefined)
            }
          />
          <Input
            groupClassName={css.Date}
            disabled={radioSelection !== 'custom'}
            label="Served At"
            type="datetime-local"
            value={contentItemDate}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setContentItemDate(e.currentTarget.value || undefined)
            }
          />
          <InfoButton
            className={css.AddButton}
            disabled={radioSelection !== 'custom'}
            size="small"
            onClick={() => {
              if (contentItemID && contentItemServes && contentItemDate) {
                const newItems = [
                  ...contentItems,
                  {
                    content_id: contentItemID,
                    served_count: Number(contentItemServes),
                    served_at: contentItemDate,
                  } as ViewedContentItem,
                ]
                setContentItems(newItems)
                onChange(newItems)
                setContentItemID('')
                setContentItemServes('')
                setContentItemDate('')
              }
            }}
          >
            Add Custom Serve
          </InfoButton>
        </div>

        <div
          className={`
            ${css.List}
            ${radioSelection !== 'custom' ? css.Disabled : ''}
          `}
        >
          {contentItems.map((contentItem) => (
            <div className={css.ListItem} key={contentItem.content_id}>
              <div className={css.ListItemDetails}>
                <div className={css.Line}>
                  <b>Contentful ID:</b> {contentItem.content_id}
                </div>
                <div className={css.Line}>
                  <b>Served Count:</b> {contentItem.served_count}
                </div>
                <div className={css.Line}>
                  <b>Served At:</b>{' '}
                  {new Date(contentItem.served_at).toDateString()}
                </div>
              </div>
              <InfoButton
                className={css.DeleteButton}
                disabled={radioSelection !== 'custom'}
                size="small"
                onClick={() => {
                  const newItems = contentItems.filter(
                    (item) => item.content_id !== contentItem.content_id
                  )
                  setContentItems(newItems)
                  onChange(newItems)
                }}
              >
                x
              </InfoButton>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ViewedContentItems
